import { useRef, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { SignOutIcon } from '@phosphor-icons/react'
import { Icon } from '@/components/ui/Icon'
import { Sheet } from '@/components/ui/Sheet'
import { ConfirmSheetFooter } from '@/components/ui/ConfirmSheetFooter'
import { toast } from '@/components/ui/Toast/toast-store'
import { logoutSession } from '@/lib/auth/session'
import './LogoutConfirmSheet.css'

export function LogoutAction() {
  const [open, setOpen] = useState(false)
  const [pending, setPending] = useState(false)
  const inFlight = useRef(false)
  const client = useQueryClient()
  const navigate = useNavigate()
  const confirm = async () => {
    if (inFlight.current) return
    inFlight.current = true
    setPending(true)
    try {
      await logoutSession(client)
      navigate('/login', { replace: true })
    } catch {
      toast.error({ title: 'خروج انجام نشد. دوباره تلاش کنید.' })
    } finally {
      inFlight.current = false
      setPending(false)
    }
  }

  return <>
    <button type="button" className="app-header__action" onClick={() => setOpen(true)}>
      <span>خروج</span>
      <Icon as={SignOutIcon} size="sm" />
    </button>
    <Sheet open={open} dismissible={!pending} onOpenChange={value => { if (!pending) setOpen(value) }} title="خروج از مامان‌پز؟">
      <div className="logout-confirm-sheet">
        <p className="logout-confirm-sheet__description">آیا تمایل دارید از اپلیکیشن خارج شوید؟</p>
        <ConfirmSheetFooter
          className="logout-confirm-sheet__actions"
          confirmLabel="خروج"
          confirmLoading={pending}
          confirmDisabled={pending}
          cancelDisabled={pending}
          onCancel={() => setOpen(false)}
          onConfirm={() => { void confirm() }}
        />
      </div>
    </Sheet>
  </>
}
